import { useTranslation } from "react-i18next";
import styles from "./History.module.scss";
import HistoryTable from "./HistoryTable/HistoryTable";
import { useGetGoalsHistoryDataQuery } from "../../../../redux/services/goalsAPI";
import { useProfileParams } from "../../../../utils/common";
import { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { isValidResponse } from "../../../../utils/validateAPIResponse";

interface HistoryProps {
  handleGoalHistoryClick: (goalHistory: HistoryItem) => void
}

const History: React.FC<HistoryProps> = ({handleGoalHistoryClick }) => {
  const { t } = useTranslation();
  const { affiliateCode, aboNumber } = useProfileParams();
  const [goalHistoryData, setGoalHitoryData] = useState([])
  
   const {
      data: getGoalsHistoryData,
      isFetching: isLoadingGetGoalsHistory,
      isError: isFetchGoalsHistoryError,
    } = useGetGoalsHistoryDataQuery(
      {
        affiliateCode,
        aboNumber,
      },
      { refetchOnMountOrArgChange: true }
    );


  useEffect(() => {
      if (!isEmpty(getGoalsHistoryData)) {
        if (isValidResponse(getGoalsHistoryData?.statusCode)) {
          setGoalHitoryData(!isEmpty(getGoalsHistoryData?.body) ? getGoalsHistoryData?.body : []);
        }
      }
    }, [getGoalsHistoryData]);

  return (
    <div
      className={`history_wrapper ${styles.history_wrapper}`}
      data-testid="history_testID"
    >
      {/* Heading */}
      <div className={styles.heading_area}>
        <span
          className={styles.heading}
          data-testid="history_bg_heading_testID"
        >
          {t("history")}
        </span>
      </div>

      {/* History Section */}
      {goalHistoryData?.length > 0 ? (
        <HistoryTable data={goalHistoryData} handleGoalHistoryClick={(goalHistory) => handleGoalHistoryClick(goalHistory)} />
      ) : (
        <div className={`history_section ${styles.history_section}`}>
          <div className={styles.empty_history}>{t("noHistoryMsg")}</div>
        </div>
      )}
    </div>
  );
};

export default History;
